
import { ReactNode } from 'react';
import { useTranslations } from 'use-intl';
import { cn } from '@/lib/utils';

type StatsCardProps = {
  label: string;
  value: string;
  icon?: ReactNode;
  trend?: {
    value: number;
    positive?: boolean;
  };
  className?: string;
};

const StatsCard = ({ label, value, icon, trend, className }: StatsCardProps) => {
  const t = useTranslations('consultantTransactions.dashboard');
  return (
    <div className={cn("stats-card glass-card border-l-4 border-l-primary", className)}>
      <div className="flex items-center justify-between">
        <span className="stats-label">{label}</span>
        {icon && <span className="text-primary">{icon}</span>}
      </div>
      <div className="stats-value text-gray-900 dark:text-gray-100">{value}</div>
      {trend && (
        <div className="mt-1 text-sm flex items-center">
          <span
            className={cn(
              "flex items-center",
              trend.positive ? "text-green-600" : "text-red-600"
            )}
          >
            {trend.positive ? "+" : "-"}{trend.value}%
          </span>
          <span className="text-muted-foreground ml-1">{t('vsLastMonth')}</span>
        </div>
      )}
    </div>
  );
};

export default StatsCard;
